package one.healthium.insights.ui.shopping_list

import androidx.compose.ui.util.fastForEach
import loco.SHOPPING_LIST_CHECKED_SECTION
import loco.SHOPPING_LIST_SCREEN_TITLE
import loco.SHOPPING_LIST_UNCHECKED_SECTION
import one.healthium.insights.domain.models.ShoppingListModel
import one.healthium.insights.domain.models.UnitModel
import one.healthium.insights.domain.shopping_list.ShoppingListDataModel
import one.healthium.insights.ui.shopping_list.models.CategoriesUiModel
import one.healthium.insights.ui.shopping_list.models.CategoryUiModel
import one.healthium.insights.ui.shopping_list.models.HeaderUiModel
import one.healthium.insights.ui.shopping_list.models.ShoppingItemUiModel
import one.healthium.loco.LString
import one.healthium.loco.asLString

internal data class ShoppingListUiState(
    val loading: Boolean = false,
    val shoppingList: ShoppingListModel? = null,
    val checkedIds: Set<String> = emptySet(),
    val shoppingListData: ShoppingListDataModel? = null,
    val isMetric: Boolean = true,
    val selectedCategoryId: String? = null,
) {
    val title: LString = shoppingList?.name?.asLString() ?: loco.Res.string.SHOPPING_LIST_SCREEN_TITLE.asLString()
    val uiData: List<Any>? = if (shoppingList != null && shoppingListData != null) {
        buildList {
            val categories = mutableSetOf<String>()
            val checkedItems = mutableListOf<ShoppingItemUiModel>()
            val uncheckedItems = mutableListOf<ShoppingItemUiModel>()

            shoppingList.items.fastForEach { item ->
                if (!item.category.isNullOrEmpty()) {
                    categories.add(item.category)
                }

                val checked = checkedIds.contains(item.id) || shoppingListData.checkedIds.contains(item.id)
                val quantity = when {
                    item.unit != null -> {
                        if (isMetric) {
                            item.unit.metric?.displayValue().orEmpty()
                        } else {
                            item.unit.imperial?.displayValue().orEmpty()
                        }
                    }

                    !item.quantity.isNullOrBlank() -> item.quantity
                    else -> ""
                }
                val uiModel = ShoppingItemUiModel(
                    id = item.id,
                    listId = shoppingList.id,
                    name = item.name,
                    emoji = item.emoji,
                    quantity = quantity,
                    checked = checked,
                    categoryId = item.category,
                )
                if (checked) {
                    checkedItems.add(uiModel)
                } else {
                    uncheckedItems.add(uiModel)
                }
            }

            val categoriesItem = if (categories.isNotEmpty()) {
                CategoriesUiModel(
                    categories = buildList {
                        add(CategoryUiModel.ALL)
                        categories.forEach { category ->
                            add(CategoryUiModel(id = category, name = category.asLString()))
                        }
                    },
                    currentCategoryId = selectedCategoryId ?: CategoryUiModel.ALL.id,
                )
            } else null

            if (uncheckedItems.isNotEmpty()) {
                add(
                    HeaderUiModel(
                        id = "header_unchecked",
                        text = loco.Res.string.SHOPPING_LIST_UNCHECKED_SECTION.asLString(),
                        categories = categoriesItem
                    )
                )
                addAll(uncheckedItems.filter { item ->
                    if (selectedCategoryId != null) {
                        item.categoryId == selectedCategoryId
                    } else {
                        true
                    }
                })
            }

            val filteredCheckedItems = checkedItems.filter { item ->
                if (selectedCategoryId != null) {
                    item.categoryId == selectedCategoryId
                } else {
                    true
                }
            }

            if (filteredCheckedItems.isNotEmpty()) {
                add(
                    HeaderUiModel(
                        id = "header_checked",
                        text = loco.Res.string.SHOPPING_LIST_CHECKED_SECTION.asLString(),
                        categories = null,
                    )
                )
                addAll(filteredCheckedItems)
            }
        }
    } else null
}

private fun UnitModel.displayValue(): String {
    val amountStr = if (amount % 1.0 == 0.0) {
        amount.toInt().toString()
    } else {
        amount.toString()
    }
    return "$amountStr $unit"
}